'use es6';

import { getUserSortKey } from './getUserSortKey';
import { toOptionWithHiddenDeletedUser } from './toOptionWithHiddenDeletedUser';
import memoize from 'transmute/memoize';
export const usersToOptionsWithFreeDisabledAndHiddenDeletedUsers = memoize(users => {
  return users.valueSeq().sortBy(getUserSortKey).map(toOptionWithHiddenDeletedUser).toArray();
});